import React from 'react';

export default ({ className, ...other }) => (
  <svg
    {...other}
    className={`icon w16 ${className || ''}`}
    viewBox="0 0 15.284 15.283"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group_447" data-name="Group 447" transform="translate(0)">
      <g id="flaticon1567704307-svg" transform="translate(0 0)">
        <path id="Path_1129" data-name="Path 1129" d="M7.642,0a7.642,7.642,0,1,0,7.642,7.642A7.65,7.65,0,0,0,7.642,0Zm0,14.774a7.132,7.132,0,1,1,7.132-7.132A7.14,7.14,0,0,1,7.642,14.774Z" fill="currentColor" />
      </g>
      <g id="flaticon1567704432-svg" transform="translate(3.221 3.871)">
        <g id="Group_446" data-name="Group 446" transform="translate(0 0)">
          <path id="Path_1131" data-name="Path 1131" d="M4.461,188.4a.235.235,0,0,0,0,.334.982.982,0,0,1,0,1.388l-2.01,2.01a.982.982,0,0,1-1.388,0l-.3-.3a.982.982,0,0,1,0-1.388l2.01-2.01a.236.236,0,1,0-.334-.334L.427,190.1a1.452,1.452,0,0,0,0,2.056l.3.3a1.456,1.456,0,0,0,2.056,0l2.01-2.01a1.456,1.456,0,0,0,0-2.056A.235.235,0,0,0,4.461,188.4Z" transform="translate(0 -185.028)" fill="currentColor" />
          <path id="Path_1132" data-name="Path 1132" d="M189.093,17.327l-.3-.3a1.456,1.456,0,0,0-2.056,0l-2.01,2.01a1.456,1.456,0,0,0,0,2.056.236.236,0,0,0,.334-.334.982.982,0,0,1,0-1.388l2.01-2.01a.982.982,0,0,1,1.388,0l.3.3a.982.982,0,0,1,0,1.388l-2.01,2.01a.237.237,0,0,0,.166.4.23.23,0,0,0,.166-.07l2.01-2.01a1.454,1.454,0,0,0,0-2.056Z" transform="translate(-181.078 -16.6)" fill="currentColor" />
        </g>
      </g>
    </g>
  </svg>
);
